export enum ActionIconPosition {
  default = 'default',
  left = 'left',
}
export enum ActionIconBackground {
  default = 'default', // dark background
  color = 'color',
}
